<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline">Rapportering:</div>

                <v-expansion-panels hover>
                    <v-expansion-panel>
                        <v-expansion-panel-header>Søknad: {{app.name}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <application-summary :id="id"></application-summary>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <div>
                                <v-badge :content="app.reports ? app.reports.length.toString() : '0'" inline>Tidligere rapporter</v-badge>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-data-table :items="app.reports" :headers="reportHeaders" hide-default-footer disable-pagination :mobile-breakpoint="0">
                                <template v-slot:item.createdBy="{item}">
                                    {{item.createdBy.firstname}} {{item.createdBy.lastname}}
                                </template>
                                <template v-slot:item.createdAt="{item}">
                                    {{moment.unix(item.createdAt).format("DD.MM.YYYY")}}
                                </template>
                            </v-data-table>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <br>
                <div class="headline">Ny rapport</div>

                <v-form>
                    <v-textarea v-model="report.description" filled label="Rapporteringsbeskrivelse"></v-textarea>
                    <div class="subtitle-1 font-weight-bold">Last opp bilag/kvittering:</div>
                    <div>Last opp regnskap, revisorbekreftelse eller kvitteringer. Bilder må være av god kvalitet dersom de skal godkjennes.</div>

                    <!-- <v-row>
                        <v-col md="11" cols="12">
                            <v-file-input v-model="files" accept=".jpg,.jpeg,.bmp,.png,.pdf" chips :show-size="1024" counter multiple label="Filnavn"></v-file-input>
                        </v-col>
                        <v-col md="1" cols="12">
                            <v-btn color="primary">Last opp</v-btn>
                        </v-col>
                    </v-row> -->

                    <v-file-input v-model="files" accept=".jpg,.jpeg,.bmp,.png,.pdf" chips :show-size="1024" counter multiple label="Filnavn" filled></v-file-input>

                    <!-- <v-checkbox v-model="requirePayment" label="Jeg ønsker utbetaling av kvalifisert beløp nå."></v-checkbox> -->
                    <v-switch v-model="requirePayment" label="Jeg ønsker utbetaling av kvalifisert beløp nå."></v-switch>

                    <v-expand-transition>
                        <v-row v-if="requirePayment">
                            <v-col md="10" cols="12">
                                <v-text-field v-model="report.account" label="Kontonummer" filled></v-text-field>
                            </v-col>
                            <v-col md="2" cols="12">
                                <v-text-field v-model="report.amount" label="Ønsket utbetalt beløp" filled :rules="[rules.inputIsNumber, rules.noDecimalMark, rules.noDecimal]"></v-text-field>
                            </v-col>
                            <!-- <v-col md="1" cols="12">
                                <v-btn @click="sendReport" color="primary" class="float-right">Send inn</v-btn>
                            </v-col> -->
                        </v-row>
                    </v-expand-transition>

                    <v-btn @click="sendReport" color="primary" class="float-right">
                        Send inn
                        <v-icon right>mdi-send</v-icon>
                    </v-btn>

                    <!-- <v-text-field v-model="report.account" label="Kontonummer"></v-text-field> -->
                    <!-- <v-text-field v-model="report.amount" label="Ønsket utbetalt beløp"></v-text-field> -->

                    <!-- <v-btn @click="sendReport" color="primary" class="float-right">Send inn rapportering</v-btn> -->
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as axios from "axios";
import * as moment from "moment"; // eslint-disable-line no-unused-vars
import { ProcurementType, ApplicationChoiceType, applicationStatusText } from "../utilities/enums";
import * as rules from "../utilities/rules";

export default {
    props: ["id"],
    data() {
        return {
            app: {
                createdBy: {}
            },
            moment: moment,
            requirePayment: false,
            report: {
                description: "",
                account: "",
                amount: 0,
                application_id: this.id,
                contents: []
            },
            reportHeaders: [
                { text: "Beskrivelse", value: "description" },
                { text: "Ønsket beløp", value: "amount" },
                { text: "Kontonummer", value: "account" },
                { text: "Bilag", value: "contents.length" },
                { text: "Opprettet av", value: "createdBy" },
                { text: "Opprettet på", value: "createdAt" }
            ],
            files: [],
            rules
        };
    },
    computed: {
        applicationBudget() {
            return this.procurementTotalByCost + this.procurementTotalByHour;
        },
        purposes() {
            if (!this.app.applicationChoices) return [];

            return this.app.applicationChoices.filter(a => a.type === ApplicationChoiceType.PURPOSE && a.selected);
        },
        area() {
            if (!this.app.applicationChoices) return { name: "-" };
            let areas = this.app.applicationChoices.filter(a => a.type === ApplicationChoiceType.AREA);
            let selectedArea = areas.find(a => a.selected);
            return selectedArea;
        },
        ageGroup() {
            if (!this.app.applicationChoices) return { name: "-" };
            let ageGroup = this.app.applicationChoices.find(a => a.type === ApplicationChoiceType.AGEGROUP && a.selected);
            return ageGroup;
        },
        procurementsByCost() {
            if (!this.app.procurements) return [];

            return this.app.procurements.filter(p => p.type == ProcurementType.COST);
        },
        procurementsByHour() {
            if (!this.app.procurements) return [];

            return this.app.procurements.filter(p => p.type == ProcurementType.HOUR);
        },
        procurementTotalByCost() {
            if (!this.procurementsByCost) return 0;

            return this.procurementsByCost.reduce((acc, cur) => {
                return acc + cur.cost;
            }, 0);
        },
        procurementTotalByHour() {
            if (!this.procurementsByHour) return 0;

            return this.procurementsByHour.reduce((acc, cur) => {
                return acc + cur.hours * this.app.hourlyRate;
            }, 0);
        },
        paymentTotal() {
            if (!this.app.payments) return 0;

            return this.app.payments.reduce((acc, cur) => {
                return acc + cur.amount;
            }, 0);
        },
        fundingsTotalOther() {
            if (!this.app.fundings) return 0;

            return this.app.fundings.reduce((acc, currentFundingOther) => {
                return acc + currentFundingOther.amount;
            }, 0);
        }
    },
    methods: {
        clearReport() {
            this.report = {
                description: "",
                account: "",
                amount: 0,
                application_id: this.id,
                contents: []
            };
            this.requirePayment = false;
            this.files = [];
        },
        applicationStatusText(status) {
            return applicationStatusText(status);
        },
        async fetchOldApplication(applicationId) {
            try {
                let application = await this.$store.dispatch("getApplication", { applicationId, include: "[createdBy,updatedBy,ownedBy,statuses,applicationChoices,procurements,procurementSplits,fundings,reports.[contents,createdBy],payments]" });
                this.app = application;
                this.report.account = this.app.account;
            } catch (error) {
                this.$store.commit("snackbar", {
                    text: "Hent av søknad feilet.",
                    color: "error"
                });
                this.$router.push({ name: "applications" });
            }
        },
        async sendReport() {
            let description = this.report.description;
            let applicationId = this.id;
            let account = this.report.account;
            let amount = this.report.amount;
            let files = this.files;

            // await this.$store.dispatch("sendReport", { description, applicationId, account, amount, files });

            // test streaming upload - start
            let reportDTO = {
                description: description,
                application_id: applicationId,
                account: account,
                amount: amount
            };

            let formData = new FormData();
            formData.append("report", JSON.stringify(reportDTO))
            let counter = 0;
            files.forEach(f => {
                formData.append(counter.toString(), f);
                counter++;
            });

            await axios.post(`/report/upload/stream/${this.id}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
            // test streaming upload - end

            this.fetchOldApplication(this.id);
            this.clearReport();
        }
    },
    watch: {
        files() {
            // let files = this.files;
            // files.forEach(f => console.log(f));
            // debugger;
        }
    },
    mounted() {
        this.fetchOldApplication(this.id);
    }
};
</script>

<style lang="scss" scoped>
.totalsum {
    border-bottom: 5px double rgba(0, 0, 0, 0.25) !important;
}
.sum {
    border-bottom: 4px double rgba(0, 0, 0, 0.12) !important;
}
.bottomborderless {
    border-bottom: none !important;
}
</style>